import { createSourceTranslator, type Locale, type TranslationCatalog } from '@shared/i18n';

const ENGLISH_UI: TranslationCatalog = {
    'Informations': 'Information',
    'les informations données lors de ce parcours clinique virtuel sont issues des recommandations pour la chirurgie de l’obésité publiée par Haute Autorité de Santé France en 2024':
        'The information provided during this virtual clinical pathway is based on the 2024 obesity surgery recommendations published by the French National Authority for Health.',
    'Mention HAS': 'French National Authority for Health notice',
    'Texte client a renseigner': 'Client copy to be provided',
    'Remplacer ce texte par la mention HAS fournie par le client.': 'Replace this text with the notice provided by the client.',
    "Médecin spécialiste de l'obésité": 'Obesity medicine specialist',
    'Progression': 'Progress',
    'Question n° {current} / {total}': 'Question {current} of {total}',
    'Vrai.': 'True.',
    'Vrai': 'True',
    'Faux': 'False',
    'Commencer': 'Start',
    'Mot de passe': 'Access code',
    'Ok': 'OK',
    'Nom': 'Last name',
    'Prénom': 'First name',
    'Année de naissance': 'Year of birth',
    'AAAA': 'YYYY',
    'Date de naissance': 'Date of birth',
    'Lieu de naissance': 'Place of birth',
    'Téléphone': 'Phone',
    'Email': 'Email',
    'Numéro de sécurité sociale': 'Social security number',
    'Profession': 'Occupation',
    'HDS': 'Healthcare data hosting',
    'Données de santé hébergées sur une infrastructure certifiée HDS, avec un niveau de sécurité adapté aux informations médicales.':
        'Health data is hosted on HDS-certified infrastructure with security safeguards appropriate for medical information.',
    'Poids (kg)': 'Weight (kg)',
    'Taille (m)': 'Height (m)',
    'IMC': 'BMI',
    'Choisir la langue': 'Choose language',
};

export function createGameTranslator(locale: Locale) {
    return createSourceTranslator(locale, ENGLISH_UI);
}
